import React from 'react'

export default class PostBox extends React.Component {
  constructor() {
    super()
    this.state = {
      text: '',
      isSaving: false
    }
  }
  onCreatePost(status) {
    let post = {
      status,
      format: 'status',
      content: this.state.text,
      title: this.state.text.replace( /^(.{50}[^\s]*).*/, '$1' )
    }
    this.setState({isSaving:true})
    window.apiHandler.post('/wp/v2/posts', post)
      .then(post => {
        this.setState({isSaving: false, text: ''})
        this.props.onDidPublish(post)
      })
  }
  render() {
    return <form className="PostBox">
    	<div className="user-detail">
    		<img src={this.props.user.avatar_urls[96]} />
    		You
    	</div>
    	<textarea
        disabled={this.state.isSaving}
        value={this.state.text}
        onChange={e => this.setState({text:e.target.value})}
        rows="4"
      />
      {this.state.isSaving ?
        <p>Saving...</p>
      :
    	  <p className="actions">
          {this.props.user.capabilities.publish_posts ?
    		  <span>
            <button
              onClick={() => this.onCreatePost('pending')}
              className="secondary">Submit for review</button>
      		  <button
              onClick={() => this.onCreatePost('publish')}
              className="primary">Publish</button>
          </span>
          :
          <span>
            <button
              onClick={() => this.onCreatePost('pending')}
              className="primary">Submit for review</button>
          </span>
          }
    	  </p>
      }
    </form>
  }
}

PostBox.propTypes = {
  user: React.PropTypes.object.isRequired,
  onDidPublish: React.PropTypes.func
}



/** WEBPACK FOOTER **
 ** ./src/PostBox.js
 **/